import type { Category as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import * as Subcategory from './Subcategory';

export type Category = {
  id: string;
  name: string;
  subcategories: Subcategory.Subcategory[];
};

export const fromGql = (item: GQLItem): Category => ({
  ...take<Category>(item, 'id', 'name'),
  subcategories: item.subcategories?.map(Subcategory.fromGql) ?? [],
});
